export default "//file.bilionpass.com/japandx-portal/0.1.22/static/img/banner.7c85ce0b-0b31e4.png";